import type { ReactNode } from 'react'

import { cn } from '#/shared/lib/utils'

interface SidebarSectionProps {
  label: string
  /** Rendered inline right after the label (left-aligned). */
  labelAction?: ReactNode
  /** Rendered at the far right of the header row. */
  action?: ReactNode
  children: ReactNode
  /**
   * Pads the section by the panel's gutter so header and body align while the
   * body's hover bleed (`-mx-2.5`) stops at an even inset from the panel edges
   * instead of touching them.
   */
  inset?: boolean
}

export function SidebarSection({
  label,
  labelAction,
  action,
  children,
  inset,
}: SidebarSectionProps) {
  return (
    <section className={cn('flex flex-col gap-1', inset && 'px-2.5')}>
      <div className="flex h-6 items-center justify-between gap-2.5">
        <div className="flex items-center gap-2.5">
          <span className="text-xs leading-none text-gray-500 uppercase select-none [text-box:trim-both_cap_alphabetic]">
            {label}
          </span>
          {labelAction}
        </div>
        {action}
      </div>
      {children}
    </section>
  )
}
